import { User } from '@driftt/api-types'
import {
  Banner,
  Box,
  Breadcrumb,
  Card,
  Flex,
  Header,
  Icon,
  Text,
} from '@driftt/dds'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'
import React, { useEffect, useState } from 'react'
import { QueryClientProvider, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'
import { Link as ReactRouterLink } from 'react-router-dom'

import { isEmptyOrNil } from 'utils/index'

import { Chat } from './components'

const PromptTesting: React.FC = () => {
  const queryClient = useQueryClient()
  //@ts-ignore
  const user = useSelector((state) => state.user)
  const [loadReady, setLoadReady] = useState(false)
  const [gptServiceError, setGptServiceError] = useState(false)
  const botUser = useSelector(
    (state) =>
      //@ts-ignore
      state.org.users.filter((orgUser: User) => {
        return orgUser.bot
      })[0]
  )

  const handleGptServiceError = () => setGptServiceError(true)

  useEffect(() => {
    if (!isEmptyOrNil(user) && !isEmptyOrNil(botUser) && !loadReady) {
      setTimeout(() => setLoadReady(true), 100)
    }
  }, [botUser, loadReady, user])

  return (
    <Box css={{ width: '100%', height: '100%' }}>
      <Flex direction="row" fullWidth fullHeight gap={0}>
        <Flex direction="column" gap={0} fullWidth fullHeight>
          <Flex direction="column" gap={0} css={{ padding: '$2 $6' }} fullWidth>
            <Flex
              direction="row"
              fullWidth
              gap={0}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <Breadcrumb.Root>
                  <Breadcrumb.Link as={ReactRouterLink} to="/playbooks">
                    Playbooks
                  </Breadcrumb.Link>
                  <Breadcrumb.Link
                    as={ReactRouterLink}
                    to="/playbooks/llm-testing"
                  >
                    Agents prompt testing
                  </Breadcrumb.Link>
                </Breadcrumb.Root>
                <Flex alignItems="center">
                  <Icon icon={faSparkles} color="purple8" />
                  <Header> Agents prompt</Header>
                </Flex>
              </Box>
            </Flex>
          </Flex>
          {gptServiceError && (
            <Banner.Root variant="warning">
              <Banner.Content>
                <Text>
                  Oh no! Something appears to have gone wrong. Please refresh
                  the page and try again
                </Text>
              </Banner.Content>
            </Banner.Root>
          )}
          <Box
            css={{
              width: '100%',
              height: '94%',
              overflow: 'hidden',
              overflowY: 'auto',
              background: '$gray2',
              padding: '$4 $6 $8',
            }}
          >
            <QueryClientProvider client={queryClient}>
              {loadReady && (
                <Flex
                  alignItems="flex-start"
                  justifyContent="center"
                  fullHeight
                  fullWidth
                  css={{ minHeight: 600 }}
                  gap={1}
                >
                  <Card
                    css={{
                      width: '100%',
                      overflow: 'hidden',
                      background: '$white',
                      height: '100%',
                    }}
                  >
                    <Chat
                      botUser={botUser}
                      onGenAiServiceError={handleGptServiceError}
                    />
                  </Card>
                </Flex>
              )}
            </QueryClientProvider>
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

export default PromptTesting
